import { useRegisterSW } from "virtual:pwa-register/react";

// eslint-disable-next-line import/no-unresolved
import { ReactComponent as UpdateIcon } from "src/assets/icons/update.svg";

import Button from "./components/button";
import { Dialog, DialogClose, DialogContent } from "./components/dialog";
import Typography from "./components/typography";
import "./ReloadPrompt.css";

// const latestChanges = `
//       - Improved search functionality
//       - Added a new dark mode option
//       - Fixed login bugs for a smoother experience
//     `;

// const latestChanges = ["New 3D Design"];
function ReloadPrompt() {
	const {
		// offlineReady: [offlineReady, setOfflineReady],
		needRefresh: [needRefresh, setNeedRefresh],
		updateServiceWorker,
	} = useRegisterSW({
		onRegistered(r: any) {
			// eslint-disable-next-line prefer-template
			console.log(`SW Registered: ${r}`);
		},
		onRegisterError(error: any) {
			console.log("SW registration error", error);
		},
		onOfflineReady() {
			console.log("App is ready to work offline.");
		},
	});

	const close = () => {
		// setOfflineReady(false);
		setNeedRefresh(false);
	};

	return (
		<div className="ReloadPrompt-container">
			<Dialog open={needRefresh}>
				<DialogContent className="flex flex-col items-center justify-center space-y-4 rounded-2xl">
					<div className="z-20 mx-auto -mt-12 flex size-20 items-center justify-center rounded-full bg-gray-200 p-2">
						<UpdateIcon />
					</div>
					<div className="flex flex-col items-center justify-center space-y-2 text-center">
						<Typography className="text-gray-800" variant="h4">
							New Update Available
						</Typography>
						<Typography className="text-gray-700" variant="bodyLG">
							A new version of the app is available. Would you like to update now
						</Typography>

						<Typography className="text-success-100" variant="bodyLG">
							for the latest features and improvements?
						</Typography>
						{/* <Typography variant="bodyXM" className="text-primary w-full p-2 text-left">
              Here’s what’s new:
            </Typography>
            <ul className="w-full px-6 list-disc">
              {latestChanges.map((item, index) => (
                <li className="w-full text-left" key={index}>
                  <Typography variant="bodyLG" className="text-gray-700 w-full text-left ">
                    {item}
                  </Typography>
                </li>
              ))}
            </ul> */}
					</div>

					<div className="flex justify-evenly">
						<DialogClose>
							<Button className="hover:bg-gray-300" variant="ghost" onClick={close}>
								<Typography className="text-gray-700" variant="h4">
									Remind Me Later
								</Typography>
							</Button>
						</DialogClose>

						{needRefresh && (
							<DialogClose>
								<Button className="hover:bg-blue-600" onClick={() => updateServiceWorker(true)}>
									<Typography className="text=white" variant="h4">
										Update Now
									</Typography>
								</Button>
							</DialogClose>
						)}
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
}

export default ReloadPrompt;
